import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'sheed-device-info',
  templateUrl: './sheed-device-info.component.html',
  styleUrls: ['./sheed-device-info.component.scss']
})
export class SheedDeviceInfoComponent implements OnInit {
  @Input('systemType') systemType: string;
  @Input('osVersion') osVersion: string;
  @Input('servicePack') servicePack: string;
  @Input('deviceOS') deviceOS: string;

  constructor() { }

  ngOnInit() {
  }


  GetOsIcon(build: string, servicePack: string): string {

    if ((!build || build.length == 0) && !servicePack) return "";

    var buildNumber = +build;
    var servicePackNumber = +servicePack;

    if (buildNumber == 6.1) {
      return "./../../../../../../assets/media/icons/dashboard/windows7-icon.png";
    } else if (buildNumber == 6.2) {
      return "./../../../../../../assets/media/icons/dashboard/windows81-icon.png";
    } else if (buildNumber == 6.3) {
      return "./../../../../../../assets/media/icons/dashboard/windows81-icon.png";
    } else if (buildNumber == 10 && servicePackNumber >= 22000) {
      return "./../../../../../../assets/media/icons/dashboard/windows11-icon.png";
    } else if (buildNumber >= 10)
      return "./../../../../../../assets/media/icons/dashboard/windows10-icon.png";
  }

  getAndroidOsVersion(deviceOS: string) {
    switch (deviceOS) {
      case '24':
        return '7.0';
      case '25':
        return '7.1';
      case '26':
        return '8.0';
      case '27':
        return '8.1';
      case '28':
        return '9.0';
      case '29':
        return '10';
      case '30':
        return '11';
      case '31':
        return '12';
      case '32':
        return '12.1';
      case '33':
        return '13';
      case '34':
        return '14';
      default:
        return '15';

    }
  }
}
